import PropTypes from 'prop-types';
import React from 'react';
import './ConfirmationSnapshot.scss';
import config from '../../../config/config';
import SellTransactionEstimation from '../../Sell/SellReview/SellTransactionEstimation/SellTransactionEstimation';
import {
  isAppBuy,
  isAppSell,
  isExchange,
  isRecurringBuy,
  isRecurringBuyEdit,
  isAutoExchange,
  isAutomaticSell,
  isSell,
  isRothConversion,
  isIRAAutoMax,
  isQCD,
} from '../../../utils/transactions-util';
import {
  APP_SUPPORT_PHONE_NUMBER,
  PRODUCT_TYPE_ENUMERATION_NAME,
  RAS_SUPPORT_PHONE_NUMBER,
} from '../../../settings/settings';
import {
  get529PhoneBranding,
  has529Phone,
} from '../../Branding/PhoneNumberBranding';

export const ConfirmationSnapshot = ({
  isSalesforceRep,
  customerWebViewEnabled,
  deliveryMethod,
  confirmationNumber,
  id,
  successIcon,
  tradeDate,
  transactions,
  appFundsOnly,
  success,
  isDistributeToSchool = false,
  selectedProductTypes = [],
}) => {
  let sameTradeDates = false;
  if (!isRothConversion()) {
    sameTradeDates = transactions.every((transaction, i, arr) => {
      return i === 0 || transaction.tradeDate === arr[i - 1].tradeDate;
    });
  }
  const multipleTransactions =
    transactions?.length > 1 ||
    transactions?.some(
      (transaction) => transaction?.transactionRecords?.length > 1
    );

  const hasManagedAccount =
    transactions.length > 0
      ? transactions[0]
        ? isSell()
          ? transactions[0].transactions
            ? transactions[0].transactions.some(
                (ele) =>
                  ele.targetPositionKey.agreementKey.productType
                    .enumerationName ===
                  PRODUCT_TYPE_ENUMERATION_NAME.MANAGED_ACCOUNT
              )
            : false
          : false
        : transactions[0].transactionRecords
        ? transactions[0].transactionRecords.some(
            (ele) =>
              ele.targetPositionKey.agreementKey.productType.enumerationName ===
              PRODUCT_TYPE_ENUMERATION_NAME.MANAGED_ACCOUNT
          )
        : false
      : false;

  const exchangeFromAPP =
    isExchange() && transactions.length > 0
      ? transactions[0].transactionRecords
        ? transactions[0].transactionRecords.some(
            (ele) =>
              ele.sourcePositionKey.agreementKey.productType.enumerationName ===
              PRODUCT_TYPE_ENUMERATION_NAME.MANAGED_ACCOUNT
          ) ||
          transactions[0].transactionRecords.some(
            (ele) =>
              ele.targetPositionKey.agreementKey.productType.enumerationName ===
              PRODUCT_TYPE_ENUMERATION_NAME.MANAGED_ACCOUNT
          )
        : false
      : false;
  const phoneNumber =
    appFundsOnly || exchangeFromAPP
      ? APP_SUPPORT_PHONE_NUMBER
      : RAS_SUPPORT_PHONE_NUMBER;

  return (
    <div id={id} className="confirmation-snapshot">
      <div className="confirmation-snapshot-header">
        {!isRecurringBuy() &&
          !isAutoExchange() &&
          !isAutomaticSell() &&
          !isAppBuy() &&
          !isAppSell() &&
          !isIRAAutoMax() &&
          !exchangeFromAPP && (
            <div className="confirmation-snapshot-trade-date">
              <span>PENDING TRADE DATE: </span>
              {isRothConversion() ||
              (transactions.length > 1 && !sameTradeDates) ||
              (isExchange() && multipleTransactions) ? (
                <span>
                  <a
                    className={'view-activities-page'}
                    href={`${config.url}/usis/my-accounts/transactions`}
                  >
                    View Activities Page
                  </a>
                </span>
              ) : (
                <span>{tradeDate}</span>
              )}
            </div>
          )}
      </div>
      <div className="confirmation-snapshot-body">
        <div className="row">
          <div className="col-xs-12 col-sm-12 col-md-3">
            <span>{successIcon}</span>
          </div>
          <div className="confirmation-snapshot-confirmation-details col-xs-12 col-sm-12 col-md-9">
            {isIRAAutoMax() && (
              <div>
                <div className="confirmation-snapshot-confirmation-details-title">
                  Success!
                </div>
                You have submitted your{' '}
                {isRothConversion() && <span>roth conversion.</span>}
                {!isRothConversion() && (
                  <span>automatic transaction request.</span>
                )}
              </div>
            )}
            {isRecurringBuy() ||
            isAutoExchange() ||
            isAutomaticSell() ||
            (!success && isRothConversion()) ? (
              isRecurringBuyEdit() ? (
                <div>
                  <div className="confirmation-snapshot-confirmation-details-title">
                    Success!
                  </div>
                  Visit the{' '}
                  <a
                    href={`${config.url}/usis/transactions/automatic`}
                    className="college-branded-link"
                    id="auto-transaction"
                  >
                    automatic transactions
                  </a>{' '}
                  page to edit or cancel.
                </div>
              ) : (
                <div>
                  <div className="confirmation-snapshot-confirmation-details-title">
                    Success!
                  </div>
                  You have submitted your{' '}
                  {isRothConversion() && <span>roth conversion.</span>}
                  {!isRothConversion() && (
                    <span>automatic transaction request.</span>
                  )}
                </div>
              )
            ) : isAppBuy() || isAppSell() || exchangeFromAPP ? (
              <>
                {(transactions.length > 1 ||
                  isExchange() ||
                  multipleTransactions) && (
                  <div className="confirmation-snapshot-pending-transactions confirmation-snapshot-space">
                    To edit or cancel your transaction, please call <br />
                    {phoneNumber}
                  </div>
                )}
                {(isExchange()
                  ? !multipleTransactions
                  : transactions.length === 1) && (
                  <div>
                    <div className="hidden-xs hidden-sm hidden-md">
                      Your submission number is:
                    </div>
                    <div className="confirmation-snapshot-confirmation-number-label visible-xs visible-sm visible-md">
                      Your submission number is:
                    </div>
                    <div
                      id="confirmation-number"
                      className="college-branded-text confirmation-snapshot-confirmation-number"
                    >
                      {confirmationNumber}
                    </div>
                  </div>
                )}
              </>
            ) : !isRothConversion() ? (
              <div>
                {!hasManagedAccount &&
                  (isExchange()
                    ? multipleTransactions
                    : transactions.length > 1) &&
                  !isQCD() && (
                    <>
                      {isDistributeToSchool ? (
                        <>
                          <span>To edit or cancel,</span>{' '}
                          {has529Phone(selectedProductTypes) ? (
                            <>
                              <span data-testid="branding">
                                <span>please call</span>{' '}
                                <a
                                  data-testid="branding-number"
                                  href={`tel:${get529PhoneBranding(
                                    selectedProductTypes
                                  )}`}
                                >
                                  {get529PhoneBranding(selectedProductTypes)}
                                </a>
                              </span>
                              {'.'}
                            </>
                          ) : (
                            <a
                              data-testid="branding-link"
                              href="https://www.troweprice.com/personal-investing/help/contact/index.html"
                              rel="noreferrer"
                              target="_blank"
                            >
                              contact us.
                            </a>
                          )}
                        </>
                      ) : (
                        <div className="confirmation-snapshot-pending-transactions confirmation-snapshot-space">
                          View submission numbers, review, cancel, or print
                          details in your{' '}
                          {!customerWebViewEnabled && isSalesforceRep ? (
                            <span>pending transactions</span>
                          ) : (
                            <span>
                              <a
                                id="confirm-pending-txn-link"
                                href={`${config.url}/usis/my-accounts/transactions`}
                              >
                                pending transactions
                              </a>
                            </span>
                          )}
                          .
                        </div>
                      )}
                    </>
                  )}
                {((isExchange()
                  ? !multipleTransactions
                  : transactions.length === 1) ||
                  isQCD()) && (
                  <>
                    <div>
                      {confirmationNumber ? (
                        <>
                          <div className="hidden-xs hidden-sm hidden-md">
                            Your submission number is:
                          </div>
                          <div className="confirmation-snapshot-confirmation-number-label visible-xs visible-sm visible-md">
                            Your submission number is:
                          </div>
                          <div
                            id="confirmation-number"
                            className="college-branded-text confirmation-snapshot-confirmation-number"
                          >
                            {confirmationNumber}
                          </div>
                        </>
                      ) : (
                        <>
                          <span>To edit or cancel,</span>{' '}
                          <a
                            data-testid="branding-link"
                            href="https://www.troweprice.com/personal-investing/help/contact/index.html"
                            rel="noreferrer"
                            target="_blank"
                          >
                            contact us.
                          </a>
                        </>
                      )}
                    </div>
                  </>
                )}
                {(isSell() || isQCD()) && (
                  <SellTransactionEstimation deliveryMethod={deliveryMethod} />
                )}
              </div>
            ) : isRothConversion() ? (
              <div className="confirmation-snapshot-pending-transactions confirmation-snapshot-space">
                View submission numbers, review, cancel, or print details in
                your{' '}
                {!customerWebViewEnabled && isSalesforceRep ? (
                  <span>pending transactions</span>
                ) : (
                  <span>
                    <a
                      id="confirm-pending-txn-link"
                      href={`${config.url}/usis/my-accounts/transactions`}
                    >
                      pending transactions
                    </a>
                  </span>
                )}
                .
              </div>
            ) : (
              <div></div>
            )}
          </div>
        </div>
      </div>
      {(isExchange() ? !multipleTransactions : transactions.length === 1) &&
        confirmationNumber &&
        !isRecurringBuy() &&
        !isAutoExchange() &&
        !isAutomaticSell() &&
        !isQCD() &&
        !isAppBuy() &&
        !isAppSell() &&
        !hasManagedAccount &&
        !isRothConversion() &&
        !exchangeFromAPP && (
          <div className="confirmation-snapshot-footer">
            <div className="confirmation-snapshot-pending-transactions">
              {isDistributeToSchool ? (
                <>
                  <span>To edit or cancel,</span>{' '}
                </>
              ) : (
                <>
                  <span className="hidden-xs hidden-sm">
                    To edit, cancel, or print, go to
                    {isAppBuy() ? ' your ' : ' '}
                  </span>
                  <span className="visible-xs-inline-block visible-sm-inline-block">
                    Review, print or cancel{' '}
                  </span>{' '}
                </>
              )}
              {!customerWebViewEnabled && isSalesforceRep ? (
                <span>pending transactions</span>
              ) : isDistributeToSchool ? (
                <>
                  {has529Phone(selectedProductTypes) ? (
                    <>
                      <span data-testid="branding">
                        <span>please call</span>{' '}
                        <a
                          data-testid="branding-number"
                          href={`tel:${get529PhoneBranding(
                            selectedProductTypes
                          )}`}
                        >
                          {get529PhoneBranding(selectedProductTypes)}
                        </a>
                      </span>
                      {'.'}
                    </>
                  ) : (
                    <a
                      data-testid="branding-link"
                      href="https://www.troweprice.com/personal-investing/help/contact/index.html"
                      rel="noreferrer"
                      target="_blank"
                    >
                      contact us.
                    </a>
                  )}
                </>
              ) : (
                <span>
                  <a
                    id="confirm-multi-txn-pending-link"
                    className="college-branded-link"
                    href={`${config.url}/usis/my-accounts/transactions`}
                  >
                    pending transactions
                  </a>
                </span>
              )}
            </div>
          </div>
        )}
      {(isExchange() ? !multipleTransactions : transactions.length === 1) &&
        (isAppBuy() ||
          isAppSell() ||
          exchangeFromAPP ||
          (!success && isRothConversion())) && (
          <div className="confirmation-snapshot-footer">
            <div className="confirmation-snapshot-pending-transactions">
              <span className="hidden-xs hidden-sm">
                To edit or cancel your transaction, please{' '}
              </span>
              <span className="visible-xs-inline-block visible-sm-inline-block">
                cancel your transaction, please
              </span>{' '}
              call {phoneNumber}
            </div>
          </div>
        )}
      {(isRecurringBuy() ||
        isAutoExchange() ||
        isAutomaticSell() ||
        isIRAAutoMax()) &&
        !isRecurringBuyEdit() &&
        !isRothConversion() && (
          <div className="confirmation-snapshot-footer">
            <div className="confirmation-snapshot-pending-transactions">
              <span className="hidden-xs hidden-sm">
                To edit, cancel, or print go to{' '}
              </span>
              <span className="visible-xs-inline-block visible-sm-inline-block">
                Review, print or cancel{' '}
              </span>
              <a
                id="confirm-multi-txn-automatic-link"
                className="college-branded-link"
                href={`${config.url}/usis/transactions/automatic`}
              >
                {' '}
                automatic transactions
              </a>
            </div>
          </div>
        )}
    </div>
  );
};

ConfirmationSnapshot.propTypes = {
  confirmationNumber: PropTypes.string,
  id: PropTypes.string,
  successIcon: PropTypes.element,
  tradeDate: PropTypes.string,
  transactions: PropTypes.array,
  appFundsOnly: PropTypes.bool,
};

export default ConfirmationSnapshot;
